jQuery(document).ready(function ($) {
  
   if ($('.question-section_block').length > 0) {
    $('.question-section_block details').click(function () {
      $('.question-section_block details').not(this).removeAttr('open');
      var attr = $(this).attr('open'); 
      if (typeof attr !== 'undefined' && attr !== false) {
        history.pushState({}, null, '?'); 
      } else { 
       var id=$(this).data('id');
        history.pushState({}, null, '?item='+id); 
         $('html, body').animate({
            scrollTop: $('#details_id_'+id).offset().top-100
        }, 1000);
      }
    })
  }

  
  
 
  
   $('.product-form__input__color label').click(function () {
    var name = $(this).data('name') ;
     var showname = $(this).data('showname') ;
     $('#product_current_color').html(showname);
    $('.product-form__input__size input').prop('disabled', false)     
    var color = ''; 
    $('.product_select__select option').each(function () {  
      var option1 = $(this).data('option1')
      var option2 = $(this).data('option2')
      var available = $(this).data('available')    
      if (name == option1) {
        color=$(this).data('color'); 
        if (available == false) {
          $('.input__size_' + option2).prop('disabled', true) ;
        }  
      }
    }) 
      $('.product-form__input__size input').each(function () {
      if ($(this).prop('checked') == true) {
        if ($(this).prop('disabled') == true) {
          $('.product-form__submit span').html('Sold out')
        } else $('.product-form__submit span').html('Add to cart')
      }
    })  
      var find_name='slider-'+name;
     $('.product_media_dann').css('display','none'); 
     $('.product_media_dann').each(function () { 
       if ($(this).hasClass(find_name)) {
         $(this).css('display','block');
         if ($(this).hasClass('slick-initialized')) {
           $(this).slick('refresh');
         }
       }
     })
     
     
     
  })
   
   
   
    $('.product-form__submit').click(function () {
      var vals=$('#current_variant_id').val();
     $(".product_select__select").val(vals).change();
      console.log(vals);
    })
   
   $('.variant_color_circle').mouseenter(function () {
    var image = $(this).data('image')
    var id = $(this).data('id')
    if (image != '') {
      $('#card_wrapper_' + id + ' .collection__image_variation').html(
        '<img src="https:' + image + '">',
      )
      $('#card_wrapper_' + id + ' .collection__image_variation').css(
        'z-index',
        '5',
      )
    }
  })

  $('.variant_color_circle').mouseleave(function () {
    $('.card-wrapper .collection__image_variation').html('')
    $('.card-wrapper .collection__image_variation').css('z-index', '0')
  })
  
 $('.facets__heading').click(function () {
    if ($('.collection__list_menu').hasClass('active')) {
      $('.collection__list_menu').removeClass('active')
    } else {
      $('.collection__list_menu').addClass('active')
    }
  })
 
 if ($('.product_media_dann').length ) {
   show_product_slider();
    $(window).resize(function () {
      show_product_slider();
    })               
 }
})

   
   function show_product_slider() {
       if (jQuery(window).width() > 992) {
         if (jQuery('.product_media_dann').hasClass('slick-initialized')) {
          jQuery('.product_media_dann').slick('unslick');
         }   
    } else {
      jQuery('.product_media_dann').slick({
      slidesToShow: 2, 
         slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false, 
      infinite: false,
      speed: 300,
      focusOnSelect: true,  
      asNavFor: '.Product__Slideshow_nav',  
      prevArrow:
      '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>'
   ,responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1
          }
        } 
      ]
      
    })
     
      jQuery('.Product__Slideshow_nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product_media_dann',
      arrows: false,
      dots: false,
      autoplay: false,
      infinite: false,
      speed: 300,
      focusOnSelect: true,
      asNavFor: '.product_media_dann',
      prevArrow:
      '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="prev" role="button"><i class="fal fa-angle-left"></i></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="next" role="button"><i class="fal fa-angle-right"></i></button>'
   ,responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    })
      
      
    }
      
    }

   